import React__default, { useState, useEffect } from 'react';
import { useUID, useIsMobile, TaktIdProvider, createStormTaktId } from '@amzn/storm-ui';
import { C as CountryRadioGroup } from '../shared/CountryRadioGroup-CUEtfZtm.js';
import { C as CountrySelectorSecondaryView } from '../shared/CountrySelectorSecondaryView-T5HeFl3c.js';
import { C as CountrySelectorTrigger } from '../shared/CountrySelectorTrigger-BEjTAcOE.js';
import { C as CountrySelectorPopover } from '../shared/CountrySelectorPopover-B-2Q6EK8.js';
import { b as adsSupportedCountries } from '../../constants/countryLists-Ck89Ck3L.js';
import { L as LoadingIndicator } from '../shared/LoadingIndicator-CiFQpbxF.js';
import { g as getTranslationComponent$1 } from '../../i18n/LoadingTranslation/static-Djd4W_1C.js';
import { g as getTranslationComponent } from '../../i18n/CountrySelectorTranslation/index-BlfEeMie.js';
import { I as IntlProvider } from '../../LocalModules/storm-ui-intl/dist/esm/IntlProvider-DUNZ897o-Dn-1_05J.js';

const CountrySingleSelector = ({
  id,
  locale = 'en-US',
  selected = '',
  countries = adsSupportedCountries,
  exclude,
  onClose,
  onSelect,
  taktId,
  taktValue,
  renderOptionsStart,
  renderOptionsEnd,
  renderHeader,
  applyButtonText
}) => {
  const uid = useUID(id);
  const isMobile = useIsMobile();
  const [isOpen, setIsOpen] = useState(false);
  const [tempCountryId, setTempCountryId] = useState(selected);
  useEffect(() => {
    setTempCountryId(selected);
  }, [selected]);
  const handleClickTrigger = () => {
    setIsOpen(true);
  };
  const handleChange = countryId => {
    setTempCountryId(countryId);
  };
  const handleClose = event => {
    onClose === null || onClose === void 0 || onClose(event);
    setIsOpen(false);
    setTempCountryId(selected);
  };
  const handleSelect = event => {
    const selectedCountry = countries.filter(country => country === tempCountryId)[0];
    onSelect === null || onSelect === void 0 || onSelect(selectedCountry, event);
    setIsOpen(false);
    setTempCountryId(selected);
  };
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('country-single-selector')
  }, /*#__PURE__*/React__default.createElement(IntlProvider, {
    resetKey: locale,
    translations: getTranslationComponent(locale),
    fallback: /*#__PURE__*/React__default.createElement(IntlProvider, {
      translations: getTranslationComponent$1(locale)
    }, /*#__PURE__*/React__default.createElement(LoadingIndicator, null))
  }, isMobile ? /*#__PURE__*/React__default.createElement(CountrySelectorSecondaryView, {
    id: uid,
    isOpen: isOpen,
    countries: countries,
    onClose: handleClose,
    onSelect: handleSelect,
    trigger: /*#__PURE__*/React__default.createElement(CountrySelectorTrigger, {
      taktId: taktId,
      onClick: handleClickTrigger,
      selected: selected ? [selected] : []
    }),
    renderOptionsStart: renderOptionsStart,
    renderOptionsEnd: renderOptionsEnd,
    applyButtonText: applyButtonText
  }, /*#__PURE__*/React__default.createElement(CountryRadioGroup, {
    id: uid,
    selected: tempCountryId,
    onChange: handleChange,
    locale: locale
  })) : /*#__PURE__*/React__default.createElement(CountrySelectorPopover, {
    id: uid,
    isOpen: isOpen,
    countries: countries,
    onClose: handleClose,
    onSelect: handleSelect,
    exclude: exclude,
    trigger: /*#__PURE__*/React__default.createElement(CountrySelectorTrigger, {
      taktId: taktId,
      onClick: handleClickTrigger,
      selected: selected ? [selected] : []
    }),
    renderHeader: renderHeader,
    renderOptionsStart: renderOptionsStart,
    renderOptionsEnd: renderOptionsEnd,
    applyButtonText: applyButtonText
  }, /*#__PURE__*/React__default.createElement(CountryRadioGroup, {
    id: uid,
    selected: tempCountryId,
    onChange: handleChange
  }))));
};

export { CountrySingleSelector as C };
//# sourceMappingURL=CountrySingleSelector-Drb4dWWb.js.map
